import { usePutWorkData } from "@/hooks/usePutWorkData";
import { useWorkDataStore } from "@/store/work.store";
import {
  ProductionActionApiWorksWorkIdDefectPutRequest,
  ProductionActionApiWorksWorkIdPerformancePutRequest,
  ProductionPlansGet200ResponseRowsInnerWorksInner,
  WorksGroupDefectPutRequest,
  WorksGroupFakeDefectPutRequest,
  WorksGroupPerformancePutRequest,
  WorksWorkIdInputPut200Response,
  WorksWorkIdDefectPutRequest,
  WorksWorkIdDeleteRequestExternalCounterSettingEnum,
  WorksWorkIdPerformancePut200Response,
  WorksWorkIdPerformancePutRequest,
} from "@sizlcorp/sizl-api-document/dist/models";
import { MutateOptions } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useCallback } from "react";

export const usePerformance = () => {
  const {
    performanceMutate,
    performanceMutateAsync,
    defectMutate,
    settingMutate,
    defectMutateAsync,
    groupPerformanceMutate,
    groupDefectMutate,
    groupDefectFakeMutate,
  } = usePutWorkData();

  const { workData } = useWorkDataStore((state) => ({
    workData: state.workData,
  }));

  const work =
    workData?.work as ProductionPlansGet200ResponseRowsInnerWorksInner;

  const workId = work?.id as number;

  const onPerformance = useCallback(
    (
      performanceRequest: WorksWorkIdPerformancePutRequest,
      options?: MutateOptions<
        AxiosResponse<WorksWorkIdPerformancePut200Response, any>,
        unknown,
        ProductionActionApiWorksWorkIdPerformancePutRequest,
        unknown
      >,
    ) => {
      return performanceMutateAsync(
        {
          worksWorkIdPerformancePutRequest: performanceRequest,
          workId: workId,
        },
        options,
      );
    },
    [workData],
  );

  const onSetting = useCallback(
    (settingType: WorksWorkIdDeleteRequestExternalCounterSettingEnum) => {
      settingMutate({
        workId: workId as number,
        worksWorkIdDeleteRequest: {
          externalCounterSetting: settingType,
        },
      });
    },
    [workData],
  );

  const onDefect = useCallback(
    (
      defectRequest: WorksWorkIdDefectPutRequest,
      options?: MutateOptions<
        AxiosResponse<WorksWorkIdInputPut200Response, any>,
        unknown,
        ProductionActionApiWorksWorkIdDefectPutRequest,
        unknown
      >,
    ) => {
      defectMutate(
        {
          workId: workId as number,
          worksWorkIdDefectPutRequest: defectRequest,
        },
        options,
      );
    },
    [workData],
  );

  const onGroupPerformance = useCallback(
    (groupPerformanceRequest: WorksGroupPerformancePutRequest) => {
      return groupPerformanceMutate({
        worksGroupPerformancePutRequest: groupPerformanceRequest,
      });
    },
    [workData],
  );
  const onGroupDefect = useCallback(
    (groupDefectRequest: WorksGroupDefectPutRequest) => {
      return groupDefectMutate({
        worksGroupDefectPutRequest: groupDefectRequest,
      });
    },
    [workData],
  );

  const onGroupFakeDefect = useCallback(
    (worksGroupFakeDefectPutRequest: WorksGroupFakeDefectPutRequest) => {
      return groupDefectFakeMutate({
        worksGroupFakeDefectPutRequest: worksGroupFakeDefectPutRequest,
      });
    },
    [workData],
  );

  return {
    onPerformance,
    onDefect,
    onSetting,
    defectMutateAsync,
    onGroupPerformance,
    onGroupDefect,
    onGroupFakeDefect,
  };
};
